// src/mapVisualLayer.js

// Expects features to have the following properties:
// - fill-color: hex color to fill the feature with
// - fill-opacity: opacity of the fill
// - line-color: hex color to outline the feature with
// - line-opacity: opacity of the outline
// - line-width: width of the outline

export function addVisualLayer({
  map,
  visualFeatures,
  visualFeaturesColor,
  beforeLayerId,
}) {
  visualFeaturesColor = visualFeaturesColor || "#000000";

  map.addSource("visual-layer", {
    type: "geojson",
    data: {
      type: "FeatureCollection",
      features: visualFeatures,
    },
  });

  // Add the fill layer before the specified layer
  map.addLayer(
    {
      id: "visual-layer",
      type: "fill",
      source: "visual-layer",
      paint: {
        "fill-color": [
          "case",
          ["has", "fill-color"],
          ["get", "fill-color"],
          visualFeaturesColor,
        ],
        "fill-opacity": [
          "case",
          ["has", "fill-opacity"],
          ["get", "fill-opacity"],
          1,
        ],
      },
    },
    beforeLayerId,
  );

  // Add the line layer if line parameters are set
  const hasLineParams = visualFeatures.some(
    (feature) =>
      feature.properties["line-color"] ||
      feature.properties["line-opacity"] ||
      feature.properties["line-width"],
  );

  if (hasLineParams) {
    map.addLayer(
      {
        id: "visual-layer-line",
        type: "line",
        source: "visual-layer",
        paint: {
          "line-color": [
            "case",
            ["has", "line-color"],
            ["get", "line-color"],
            visualFeaturesColor,
          ],
          "line-opacity": [
            "case",
            ["has", "line-opacity"],
            ["get", "line-opacity"],
            1,
          ],
          "line-width": [
            "case",
            ["has", "line-width"],
            ["get", "line-width"],
            1,
          ],
        },
      },
      beforeLayerId,
    );
  }

  if (process.env.NODE_ENV === "development") {
    // Add click event listener
    map.on("click", "visual-layer", function (e) {
      if (e.features && e.features.length > 0) {
        console.log("Clicked feature:", e.features[0]);
      }
    });

    // Debug for showing feature IDs
    map.addLayer(
      {
        id: "visual-layer-labels",
        type: "symbol",
        source: "visual-layer",
        layout: {
          "text-field": "{@id}",
          "text-font": ["Open Sans Regular", "Arial Unicode MS Bold"],
          "text-size": 12,
          "text-offset": [0, 1.5],
        },
        paint: {
          "text-color": "#000000",
        },
      },
      beforeLayerId,
    );
  }
}
